<template>
  <div class="content">
    <div class="tab">
      <div
        class="tab-item"
        v-for="(tab, idx) in app"
        :key="idx"
        :class="{ selected: selectedTabIndex === idx }"
        @click="selectedTab(idx)"
      >
        {{ tab.name }}
      </div>
    </div>
    <div class="tab-content">
      <div class="item" v-for="item in appContent" :key="item.id" @click="selectApp(item)">
        <img :src="item.img" alt="">
        <a-tooltip>
          <template slot="title">
            {{ item.name }}
          </template>
          <div class="headline">{{ item.name }}</div>
        </a-tooltip>
        <a-tooltip placement="bottom">
          <template slot="title">
            {{ item.desc }}
          </template>
          <div class="desc">{{ item.desc }}</div>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/data/app.js'

export default {
  data() {
    return {
      app: [{
        name: this.$t('aiApp.all'),
        children: []
      }, ...app],
      selectedTabIndex: 0,
      appContent: []
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 选择app的tab
    selectedTab(index) {
      console.log('index', index)
      this.selectedTabIndex = index
      if (index === 0) {
        this.appContent = []
        this.app.forEach(item => {
          console.log('item', item)
          item.children.forEach(child => {
            this.appContent.push(child)
          })
        })
      } else {
        this.appContent = this.app[index].children
      }
    },
    selectApp(item) {
      if (item.type === 'course') {
        this.$router.push({
          path: '/courses/generationCourse'
        })
      } else if (item.type === 'teachingPlan') {
        this.$router.push({
          path: '/AI/chat/teaching-plan'
        })
      } else {
        this.$router.push({
          name: 'aiAppDetail',
          query: {
            id: item.id
          }
        })
      }
    }
  },
  mounted () {
    this.selectedTab(0)
  }
}

</script>

<style scoped lang="less">
.content{
  padding: 30px;
  .tab{
    display: flex;
    align-items: center;
    flex: 1;
    .tab-item{
      width: 70px;
      height: 40px;
      border-radius: 12px;
      border: 1px solid #EDEDED;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      cursor: pointer;
    }
    .selected{
      color: #fff;
      background: linear-gradient( 210deg, #FF9E3F 0%, #FF6203 100%);
    }
  }
  .tab-content{
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    .item{
      width: 18%;
      margin-right: 2.5%;
      height: 110px;
      border-radius: 12px;
      border: 1px solid #EDEDED;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 13px 19px;
      cursor: pointer;
      margin-bottom: 40px;
      transition: all 0.3s ease; /* 添加过渡效果 */
      img{
        width: 27px;
        height: 27px;
      }
      .headline{
        font-weight: 700;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        margin-top: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .desc{
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        line-height: 17px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .item:hover {
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
      cursor: pointer; /* 鼠标悬停时显示手型 */
      .headline{
        color: #FF6506;
      }
    }
    .item:nth-child(5n){
      margin-right: 0;
    }
    .item.selected {
      border: 1px solid #FF6506;
      .headline{
        color: #FF6506;
      }
    }
  }
}
</style>
